<script setup>
import { ref } from 'vue'
import apiCustomer from '../../api/customer.api'
import { debounce } from 'quasar';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const customer = ref(null)
const customerOptions = ref([])
const page = ref(null)
const lastPage = ref(false)
const loading = ref(false)

async function getCustomerList (params) {
  loading.value = true
  const { data: { data: { customers: _customers, page: _page, lastPage: _lastPage } } } = await apiCustomer.getList(params)

  customerOptions.value = Object.freeze(_customers)
  page.value = _page
  lastPage.value = _lastPage
  loading.value = false
}

const filter = debounce((value) => {
  if (!value.length) {
    getCustomerList()
  }
  if (value.length >= 4) {
    getCustomerList({
      query: value
    })
  }
}, 500)

function paginate (jump) {
  getCustomerList({
    page: parseInt(page.value) + jump
  })
}

getCustomerList()
</script>

<template lang='pug'>
.base-input-customer
  q-select(
    @update:model-value='value => $emit("data", value)'
    @input-value='filter'
    @new-value='(value, done) => $emit("new-value", value, done)'
    style='min-width: 200px; max-width: 300px;'
    stack-label
    outlined
    :loading='loading'
    v-model='customer'
    :options='customerOptions'
    :label="t('customer.car_numbers')"
    :multiple='false'
    hide-dropdown-icon
    option-label='plateNumber'
    option-value='_id'
    :transition-duration='0'
    no-error-icon
    options-dense
    use-input
    hide-hint
    :popup-content-style=`{ 'width': 'auto' }`
    popup-content-class='maxHeightClass'
  )
    template(v-slot:no-option='scope')
      .q-pa-sm {{ t('base.no_data') }}
    template(v-slot:option='{ itemProps, opt, selected, toggleOption }')
      q-item(v-bind='itemProps' style='padding: 0 5px')
        q-item-section(side)
          q-checkbox(
            :model-value='selected'
            @update:model-value='toggleOption(opt)'
          )
        q-item-section
          q-item-label.text-bold.q-pr-sm {{ opt.plateNumber }}
    template(v-slot:after-options)
      .row.justify-center
        .col
          q-btn.full-width(
            color='primary'
            :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
            unelevated
            flat
            icon='chevron_left'
            :disable='page == 1'
            @click=`paginate(-1)`
          )
        .col
          q-btn.full-width(
            color='primary'
            :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
            unelevated
            flat
            icon='chevron_right'
            :disable='lastPage'
            @click=`paginate(1)`
          )
</template>